import get from 'lodash/get';

import { createSelector } from 'reselect';

export const selectRootState = state =>
  get(state, 'managePatientInsurances.common');

export const selectInsuranceRelatedDataFetching = createSelector(
  selectRootState,
  state => get(state, 'pending', false),
);

export const selectUploadInsuranceCardModalData = createSelector(
  selectRootState,
  state => get(state, 'uploadInsuranceCardModal'),
);

export const selectInsuranceToDoTaskCompleting = createSelector(
  selectRootState,
  state => get(state, 'isInsuranceToDoTaskCompleting', false),
);



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/selectors/common.js